import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@env/environment';
import {
  B2B_PORTAL_ROUTES,
  DIGITAL_HUB_ROUTES,
} from '@core/constants/app-routes.const';

export const portalAccessGuard: CanActivateFn = route => {
  const router = inject(Router);
  const requestedPath = route.url[0]?.path || route.routeConfig?.path || '';

  const isB2BPortal = environment.appName === 'b2b-portal';
  const allowedRoutes = isB2BPortal ? B2B_PORTAL_ROUTES : DIGITAL_HUB_ROUTES;
  const isAllowed = allowedRoutes.some(allowedRoute =>
    requestedPath.startsWith(allowedRoute)
  );

  if (!isAllowed) {
    router.navigate([environment.homeRoute]);
    return false;
  }

  return true;
};
